import { render, staticRenderFns } from "./senior_pop.vue?vue&type=template&id=2f42ad30&"
import script from "./senior_pop.vue?vue&type=script&lang=js&"
export * from "./senior_pop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports